import { computed, Injectable, signal } from '@angular/core';
import dayjs from 'dayjs';
import { Subject } from 'rxjs';
import { IAuditorium } from '../interfaces/IAuditoriums';
import { IShow } from '../interfaces/IShow';
import { IShowPriceCategory } from '../interfaces/IShowPriceCategory';

@Injectable({
  providedIn: 'root'
})
export class ShowsStore {

  public readonly shows = signal<IShow[]>([]);
  public readonly selectedShow = signal<IShow>(null);
  public readonly selectedDay = signal<dayjs.Dayjs>(null);
  public readonly isDashboardTwoWeeksView = signal(false);
  public readonly dashboardTwoWeeksAuditoriumId = signal<number | null>(null);
  public readonly isShowPageTwoWeeksView = signal(false);
  public readonly isAllAuditoriumsSelected = signal(false);
  public readonly showMovedModalOpen$ = new Subject<void>();
  public readonly selectedAuditorium = signal<number>(null);
  public readonly showPriceCategories = signal<IShowPriceCategory[]>([]);
  public readonly showReservationPriceCategory = computed(() =>
    this.showPriceCategories().find(c => c.flagReservation)
  );
  public readonly auditoriums = computed<IAuditorium[]>(() => {
    const shows = this.shows();
    const auditoriumsMap = new Map<number, IAuditorium>();

    shows.forEach(show => {
      if (!auditoriumsMap.has(show.auditorium.id)) {
        auditoriumsMap.set(show.auditorium.id, show.auditorium);
      }
    });

    return Array.from(auditoriumsMap.values()).sortByKey('name');
  });
}
